module.exports = __webpack_public_path__ + "static/profilePic-eedd42313ec3d08dc3a26285f5fd04f7.jpg";